import { gql } from "@apollo/client";

export const GET_USER = gql`
query GetUser {
  getUser {
    _id
    email
    name
    presentations {
      _id
      uuid
      title
      thumbnail
    }
  }
}`

export const GET_PRESENTATION = gql`
query GetPresentation($getPresentationId: String) {
  getPresentation(id: $getPresentationId) {
    _id
    slides
    title
    thumbnail
  }
}`

export const GET_PRESENTATION_STATUS = gql`
query GetPresentation($getPresentationId: String) {
  getPresentation(id: $getPresentationId) {
    _id
    status
  }
}`

export const GET_PRESENTATION_TITLE = gql`
query GetPresentation($getPresentationId: String) {
  getPresentation(id: $getPresentationId) {
    _id
    title
  }
}`

export const GET_ONE_PRESENTATION = gql`
query GetPresentation($getPresentationId: String) {
  getPresentation(id: $getPresentationId) {
    _id
    code
    title
    status
    allSlides {
      _id
      background
      bgType
      elements
      answers {
        _id
        answer
        createdAt
        participantId
      }
    }
    participants {
      _id
      name
      uuid
    }
  }
}`

export const GET_JOIN_PRESENTATION = gql`
query GetOnePresentation($code: Float) {
  getOnePresentation(code: $code) {
    _id
    uuid
    status
    activeSlide
    allSlides {
      _id
      elements
    }
  }
  getParticipant {
    _id
    name
    answers {
      _id
      answer
      slideId
    }
  }
}`

export const GET_PARTICIPANT = gql`
query GetParticipant {
  getParticipant {
    _id
    answers {
      _id
      answer
      slideId
    }
  }
}`

export const GET_IMAGES = gql`
query GetImages($search: String) {
  getImages(search: $search) {
    id
    type
    previewURL
    largeImageURL
  }
}`

export const GET_GIFS = gql`
query GetGifs($search: String, $type: String) {
  getGifs(search: $search, type: $type) {
    id
    type
    medium
    large
  }
}`